import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import { mainListItems } from "./listItems";
import TtecLogo from "assets/images/ttecLogo.png";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

const drawerWidth = 82.5;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    flexShrink: 0,
    whiteSpace: "nowrap",
    width: drawerWidth,
    boxSizing: "border-box",
    height: "100vh",
    backgroundColor: "#3299FF",
    color: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  "& .MuiListItemIcon-root": {
    color: "#ffffff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "background-color 0.3s, color 0.3s, border 0.3s",
    width: "48px",
    height: "48px",
    position: "relative",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.75rem", // Increase icon size
  },
  "& .MuiListItemButton-root": {
    padding: "4px 8px", // Adjust padding for list item
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover .MuiListItemIcon-root::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#ffffff",
      border: "1px solid #3299FF",
      borderRadius: "4px",
      zIndex: -1,
    },
    "&:hover .MuiListItemIcon-root": {
      color: "#3299FF",
      zIndex: 1,
    },
  },
}));

const defaultTheme = createTheme();

export default function SideBarLayout() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/welcome");
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Drawer variant="permanent">
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="button"
            onClick={handleClick}
            sx={{
              border: "none",
              background: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            <Box
              component="img"
              src={TtecLogo}
              alt="TTEC"
              sx={{
                height: "3.5rem",
                width: "1.9rem",
              }}
            />
          </Box>
        </Toolbar>
        <List>{mainListItems}</List>
      </Drawer>
    </ThemeProvider>
  );
}
